import { RoomState } from '@airhead-games/shared/types';
import { useRoomStateSnapshot } from '../contexts/roomStateStore';

export const useRoomStateSelector = <T>(
  selector: (state: RoomState | null) => T
): T => {
  return useRoomStateSnapshot(selector);
};
